document.addEventListener("DOMContentLoaded", () => {

  //Temporary Fix
  // const wrapObj = document.querySelector("#recharge-storefront-experiences").parentElement;
  // wrapObj.style.position = 'relative';
  // wrapObj.style.zIndex = '1000000';
  
  // DOM hooks / config
  const giftProduct = document.querySelector(".gift-product");
  if (!giftProduct) return;

  const variantId = Number(giftProduct.dataset.variantId);
  // const discountCode = giftProduct.dataset.discount;
  // const giftThreshold = Number(giftProduct.dataset.price); // threshold rule
  const customerGift = giftProduct.dataset.customerGift === 'true'; // threshold rule
  const GIFT_PROP = "_auto_gift"; // unique property to mark the gift line

  let isUpdatingGift = false; // lock to avoid racing duplicate calls

  // if (document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet')) {
  //   disableGiftRemoveButtons(document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet'));
  // }

  // Watch for cart drawer open and disable remove buttons on gift products
  // function observeRechargeCartDrawer() {
  //   const rechargeRootEl = document.querySelector("#recharge-storefront-experiences");

  //   if (!rechargeRootEl) return;
  //   const cartDrawer = rechargeRootEl.querySelector("#recharge-storefront-experiences__cart-drawer");
  //   if (!cartDrawer || !cartDrawer.shadowRoot) return;
  //   const shadow = cartDrawer.shadowRoot;

  //   const observer = new MutationObserver(() => {
  //     const cartSheet = cartDrawer.shadowRoot?.querySelector("#CartSheet");
  //     if (cartSheet) {
  //       // Run your function when drawer is available
  //       disableGiftRemoveButtons(cartSheet);
  //     }
  //   });

  //   observer.observe(shadow, { childList: true, subtree: true });
  // }

  // Initialize observer after DOM is ready
  // observeRechargeCartDrawer();

  // --- Utilities -------------------------------------------------------------

  function disableGiftRemoveButtons(rechargeCart) {
  // Find all cart items inside shadow DOM
    const cartItems = rechargeCart.querySelectorAll("[role=listitem]");
    // cartItems.forEach(item => {
    //   const priceEl = item.querySelector("span[part='money discount']");
    //   if (!priceEl) return;

    //   const priceText = priceEl.textContent.replace(/[^0-9.]/g, "");
    //   const price = parseFloat(priceText);

    //   if (price === 0) {
    //     const removeBtn = item.querySelector(".lucide.lucide-trash2").closest("[data-slot='button']");
    //     const plusBtn = removeBtn.closest('div').querySelector('.lucide-circle-plus').closest('button');
    //     const minusBtn = removeBtn.closest('div').querySelector('.lucide-circle-minus').closest('button');
    //     const inputArea = plusBtn.closest('div').querySelector('input');

    //     if (removeBtn) {
    //       // Disable interaction with remove button
    //       removeBtn.style.pointerEvents = "none";
    //       removeBtn.style.cursor = "not-allowed";
    //       removeBtn.title = "This gift cannot be removed";
    //       removeBtn.setAttribute("aria-disabled", true);
    //     }

    //     if (minusBtn) {
    //       // Disable interaction with minus button
    //       minusBtn.setAttribute("aria-disabled", true);
    //       minusBtn.style.cursor = "not-allowed";
    //       minusBtn.style.pointerEvents = "none";
    //     }

    //     if (plusBtn) {
    //       // Disable interaction with plus button
    //       plusBtn.setAttribute("aria-disabled", true);
    //       plusBtn.style.cursor = "not-allowed";
    //       plusBtn.style.pointerEvents = "none";
    //     }

    //     if (inputArea) {
    //       // Disable interaction with input area
    //       inputArea.setAttribute("disabled", true);
    //       inputArea.setAttribute("readonly", true);
    //     }
    //   }
    // });
  }

  // Fetch the full cart object safely (with a tiny delay so discounts can settle)
  const fetchCart = (delay = 400) =>
    new Promise(resolve => {
      setTimeout(() => {
        fetch("/cart.js")
          .then(r => r.json())
          .then(resolve)
          .catch(() => resolve(null));
      }, delay);
    });

  // Add the free gift as a distinct line using a unique line item property
  async function addFreeGift() {
    try {
      isUpdatingGift = true;
      // await fetch("/cart/update.js", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json", Accept: "application/json" },
      //   body: JSON.stringify({
      //     discount: discountCode
      //   }),
      // });
      // console.log("🏷️ Discount applied to gift");

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            // This property keeps the gift as a separate line from the same paid variant
            properties: { [GIFT_PROP]: "1" }
          }]
        }),
      });
      console.log("🎁 Gift added");
    } catch (e) {
      console.error("❌ Error adding gift or applying discount", e);
    } finally {
      setTimeout(() => (isUpdatingGift = false), 1200);
    }
  }

  // Remove a specific line by its key (not by variantId!)
  async function removeLineByKey(lineKey) {
    try {
      isUpdatingGift = true;
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          // 'id' here is the line item key, so only the gift line is removed
          id: lineKey,
          quantity: 0,
        }),
      });
      console.log("🗑️ Gift removed by key");
    } catch (e) {
      console.error("❌ Error removing gift", e);
    } finally {
      setTimeout(() => (isUpdatingGift = false), 1200);
    }
  }

  // Find the gift line (marked by our unique property)
  function findGiftLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.find(item =>
      Number(item.id) === variantId &&
      item.properties &&
      (item.properties[GIFT_PROP] === "1" || item.properties[GIFT_PROP] === 1 || item.properties[GIFT_PROP] === true)
    ) || null;
  }

  // Main decision: add/remove gift based on threshold and gift state
  async function checkGift(cart) {
    if (isUpdatingGift || !cart) return;

    // if (document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet')) {
    //   disableGiftRemoveButtons(document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet'));
    // }

    // Shopify returns subtotal in cents
    
    const productCondition = cart.items.some(item => {
      return item.options_with_values.some(option => option.name === "Pack Size" && option.value === "3 Pack");
    })
    console.log(productCondition, 'productCondition')
    const giftLine = findGiftLine(cart);
    const giftInCart = Boolean(giftLine);

    // If subtotal exceeds threshold and gift is not in cart → add it
    if (customerGift && !giftInCart && productCondition) {
      await addFreeGift();
      return;
    }

    // // If subtotal is below/equal threshold and gift is present → remove only the gift line
    if (giftInCart && (!productCondition || !customerGift)) {
      await removeLineByKey(giftLine.key);
      return;
    }

    // If gift is present but it's no longer free (lost discount), remove the gift line only.
    // This prevents the "gift becomes paid" edge case.
    // if (giftInCart && (giftLine.line_price || 0) > 0) {
    //   console.log("⚠️ Gift lost its discount, removing gift line only…");
    //   await removeLineByKey(giftLine.key);
    //   return;
    // }

    // Note: if a user adds the same variant as a paid item, it will be a separate line
    // without our _auto_gift property, so we never remove it here.
  }

  // --- Fetch interception to react to cart changes ---------------------------

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    // if (document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet')) {
    //   disableGiftRemoveButtons(document.querySelector("#recharge-storefront-experiences__cart-drawer").shadowRoot.querySelector('#CartSheet'));
    // }

    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0]?.url || "");
      if (url.includes("/cart") && response.ok) {
        // For endpoints other than /cart.js, fetch the full cart after a short delay,
        // because /cart/add|change responses may not include full cart.
        if (url.includes("/cart.js")) {
          // If it's already /cart.js, use the payload directly
          const data = await response.clone().json().catch(() => null);
          if (data && data.items) checkGift(data);
        } else {
          const cart = await fetchCart(400);
          if (cart) checkGift(cart);
        }
      }
    } catch (e) {
      // Fail-safe: never block the original response
      console.debug("fetch hook silent error:", e);
    }

    return response;
  };

  // Initial check on page load
  fetchCart(0).then(checkGift);
});
